import * as XLSX from 'xlsx';
import { serializeCandidateReportWorkbook } from '../../candidateReportWorkbook';

export type PsychBedReport = { title: string; fields: string[]; labels: string[]; sequentialIds: boolean; rows: Array<{ cells: Array<{ key: string; value: string | null }> }> };

export const buildPsychBedReportWorkbook = async (report: PsychBedReport, password: string): Promise<ArrayBuffer> => {
  const sheet = XLSX.utils.aoa_to_sheet([
    [report.title], [], report.labels,
    ...report.rows.map((row, index) => {
      const cells = Object.fromEntries(row.cells.map((cell) => [cell.key, cell.value]));
      return report.fields.map((key) => report.sequentialIds && key === 'id' ? index + 1 : cells[key] ?? '');
    }),
  ]);
  sheet['!cols'] = report.fields.map((key) => ({ wch: key === 'odr_team_confidentiality' ? 60 : key === 'name' ? 30 : 23 }));
  sheet['!merges'] = [XLSX.utils.decode_range(`A1:${XLSX.utils.encode_col(report.fields.length - 1)}1`)];
  if (password) sheet['!protect'] = { password, sort: true, insertRows: false, formatCells: false };
  const workbook = XLSX.utils.book_new();
  workbook.Props = { Title: report.title, Subject: report.title, Author: 'LA County Diversion' };
  XLSX.utils.book_append_sheet(workbook, sheet, 'Report');
  return serializeCandidateReportWorkbook(workbook, password);
};
